<template>
  <div class="uk-margin">
    <div class="uk-form-controls uk-flex uk-flex-column">
        <label class="kmc-checkbox">
            <input type="checkbox"
                   :name="name"
                   :disabled="disabled"
                   :required="required"
                   :checked="checked"
                   @change="handleChange(true)" />
            <span class="uk-width-1-1 uk-text-center" v-html="displayLabel">
            </span>{{ required ? '*' : '' }}
        </label>
    </div>
    <div class="kmc-field-help-text" v-if="helpText"> 
        <p v-html="helpText"></p>
    </div>

    <div class="kmc-field-error-text">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import {computed, ref} from 'vue';
import {useField} from "vee-validate";

export default {
  name: "KmcInputCheckbox",
  props: {
    helpText: {
      type: String,
    },
    value: {
      type: String,
      default: "",
    },
    modelValue: {
      type: null,
    },
    inverted: {
      type: Boolean
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    disabled: {},
    required: {},
  },
  setup: function (props, context) {

    const input = ref()

    const {
      errorMessage,
      handleChange,
      checked
    } = useField(props.name, undefined, {
      type: 'checkbox',
      checkedValue: true,
      uncheckedValue: false,
    });

    const displayLabel = computed(() => {
      return `${props.label}${props.required ? '*' : ''}`
    })

    return {
      input,
      errorMessage,
      displayLabel,
      handleChange,
      checked
    };
  }
}

</script>

